import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { CfCheckboxComponent } from '../checkbox/checkbox.component';
import { ItemModel } from '../../models/item/item.model';
import { ItemStylingModel } from '../../models/item/item-styling.model';
import { ItemTemplates } from '../../templates/item.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p> The item component can be used anywhere as a general item or inside cf-list component as a list item.</p>
 * <p> The item component consists of 2 tabs: Default template (always shown) and the details template.</p>
 */
export class CfItemComponent extends CfCoreComponent implements OnInit {
/**
 * @hidden
 */
checkbox: CfCheckboxComponent;
/**
 * It is an attribute <b>[properties]</b> of directive <b>cf-item</b> which take ItemModel object.
 * <p>Example of model:</p>
 * <pre>{{'{'}}
 *  disable: true,
 *  details: true,
 *  selected: true,
 *  selectable: true,
 *  withCheckbox: true
 * {{'}'}}</pre>
 * <h4>disable: boolean</h4>
 * If item is disable to select/unselect
 * <h4>details: boolean</h4>
 * If item will have details section in html
 * <h4>selected: boolean</h4>
 * If item is selected
 * <h4>selectable: boolean</h4>
 * If item is selectable
 * <h4>withCheckbox: boolean</h4>
 * If item will have checkbox
 */
properties: ItemModel;
/**
 * It is an attribute <b>[styling]</b> of <b>cf-item</b> which take ItemStylingModel object with next properties:
 * <h4>container: StylingModel</h4>
 * Styling properties for component container
 * <h4>item: StylingModel</h4>
 * Styling properties for item if it is not selected
 * <h4>selectedItem: StylingModel</h4>
 * Styling properties for item if it is selected
 */
styling: ItemStylingModel;
/**
 * True if the item will contain a details tab
 * @param {?} value
 * @return {?}
 */
set details(value: boolean) { this.properties.details = value; }
/**
 * True if the item will be selectable
 * @param {?} value
 * @return {?}
 */
set selectable(value: boolean) { this.properties.selectable = value; }
/**
 * True if the item will be displayed with checkbox
 * @param {?} value
 * @return {?}
 */
set withCheckbox(value: boolean) { this.properties.withCheckbox = value; }
/**
 * True if the item will be selected
 * @param {?} value
 * @return {?}
 */
set selected(value: boolean) { this.properties.selected = value; this.selectedChange.emit(value); }
/**
 * @hidden
 */
selectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
/**
 * @hidden
 */
itemClicked = new EventEmitter();
/**
 * @hidden
 */
internalId: number;
/**
 * @hidden 
 * Set to true when the user presses on the details icon.
 */
showDetails = false;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /** @hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new ItemModel();
    this.styling = new ItemStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('item', ItemTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'ITEM').then( sampler => {
        // console.log('ITEM', this);
      });
    });
  }
/**
 * @hidden
 * @return {?}
 */
selectMe() {
    if (this.properties.selectable === true && !this.properties.disable) {
      this.properties.selected = !this.properties.selected;
      this.itemClicked.emit({ 'id': this.internalId, 'value': this.properties.selected });
    }
  }
/**
 * @hidden
 * @return {?}
 */
notifyList() {
    if (this.properties.selectable === true && !this.properties.disable) {
      this.itemClicked.emit({ 'id': this.internalId, 'value': !this.properties.selected });
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-item',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-item-container'\"> <md-list-item layout=\"row\" class=\"{{properties?.disable ? 'disable' : ''}} {{properties?.selected ? 'selected' : ''}}\" [ngClass]=\"properties?.selected ? styling?.selectedItem?.class: styling?.item?.class\"> <div class=\"cf-list-item-action\"> <cf-checkbox [disable]=\"properties?.disable\" (click)=\"notifyList()\" [hidden]=\"(!properties?.selectable || !properties?.withCheckbox)\" [(checked)]=\"properties.selected\" item=\"\"></cf-checkbox> <div class=\"cf-list-item-action\" (click)=\"selectMe()\"> <ng-content></ng-content> </div> <cf-icon md-list-icon name=\"arrow_right\" *ngIf=\"properties?.details\" class=\"cf-list-item-trigger\" [ngClass]=\"{'cf-expanded' : showDetails}\" (click)=\"showDetails=!showDetails\"></cf-icon> </div> <div (click)=\"selectMe()\" [hidden]=\"!showDetails\" class=\"cf-list-item-details-container\"> <ng-content class=\"cf-list-item-details\" [ngClass]=\"{'cf-expanded' : showDetails}\" select=\"[details]\"></ng-content> </div> </md-list-item> </div>",
  styles: [".cf-list-item-action { width: 100%; display: flex; flex-direction: row; align-items: center; font-family: 'Avenir', \"Helvetica Neue\", sans-serif; box-sizing: border-box; font-size: 16px; padding: 8px 0; } .cf-list-item-action > cf-checkbox { margin-right: 16px; } .cf-list-item-details { transition: all .5s; display: none; } .cf-list-item-details.cf-expanded { transition: all .5s; display: block; } .cf-list-item-trigger { transition: all .5s; z-index: 100; } .cf-list-item-trigger.cf-expanded { transform: rotate(90deg); } .cf-list-item-details-container { width: 100%; font-family: 'Avenir', \"Helvetica Neue\", sans-serif; } [hidden] { display: none !important; } .item { background-color: white; } .itemSelected { background-color: lightgray; } :host ::ng-deep md-list-item.mat-list-item.disable { background-color: rgba(211, 211, 211, 0.75); } :host ::ng-deep md-list-item.mat-list-item.disable .mat-list-item-content { cursor: default; } :host ::ng-deep md-list-item.mat-list-item.disable:hover { background-color: rgba(211, 211, 211, 0.75); } :host ::ng-deep md-list-item.mat-list-item.disable:hover .mat-list-item-content { cursor: default; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'checkbox': [{ type: ViewChild, args: [CfCheckboxComponent, ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'details': [{ type: Input, args: ['details', ] },],
'selectable': [{ type: Input, args: ['selectable', ] },],
'withCheckbox': [{ type: Input, args: ['withCheckbox', ] },],
'selected': [{ type: Input, args: ['selected', ] },],
'selectedChange': [{ type: Output },],
'itemClicked': [{ type: Output },],
};
}

function CfItemComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfItemComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfItemComponent.ctorParameters;
/** @type {?} */
CfItemComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfItemComponent.prototype.checkbox;
/**
 * It is an attribute <b>[properties]</b> of directive <b>cf-item</b> which take ItemModel object.
 * <p>Example of model:</p>
 * <pre>{{'{'}}
 *  disable: true,
 *  details: true,
 *  selected: true,
 *  selectable: true,
 *  withCheckbox: true
 * {{'}'}}</pre>
 * <h4>disable: boolean</h4>
 * If item is disable to select/unselect
 * <h4>details: boolean</h4>
 * If item will have details section in html
 * <h4>selected: boolean</h4>
 * If item is selected
 * <h4>selectable: boolean</h4>
 * If item is selectable
 * <h4>withCheckbox: boolean</h4>
 * If item will have checkbox
 * @type {?}
 */
CfItemComponent.prototype.properties;
/**
 * It is an attribute <b>[styling]</b> of <b>cf-item</b> which take ItemStylingModel object with next properties:
 * <h4>container: StylingModel</h4>
 * Styling properties for component container
 * <h4>item: StylingModel</h4>
 * Styling properties for item if it is not selected
 * <h4>selectedItem: StylingModel</h4>
 * Styling properties for item if it is selected
 * @type {?}
 */
CfItemComponent.prototype.styling;
/**
 * @hidden
 * @type {?}
 */
CfItemComponent.prototype.selectedChange;
/**
 * @hidden
 * @type {?}
 */
CfItemComponent.prototype.itemClicked;
/**
 * @hidden
 * @type {?}
 */
CfItemComponent.prototype.internalId;
/**
 * @hidden 
 * Set to true when the user presses on the details icon.
 * @type {?}
 */
CfItemComponent.prototype.showDetails;
/**
 * @hidden
 * @type {?}
 */
CfItemComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
